import Vue from 'vue'
import VueGtag from 'vue-gtag'
if (process.env.appEnv == 'live') {
    Vue.use(VueGtag, {
        config: { id: process.env.ga4Key },
    })
}
